<template>
  <div>
    <Jumbotron title="" />

    <!-- dekstop -->
    <b-container class="d-none d-sm-block" style="margin-top: -75px;">
      <b-row class="m-3 p-4 sg-rounded-container">
        <b-col cols="12">
          <h2>Destinasi Wisata Keluarga Cemara</h2>
        </b-col>

        <b-col cols="10" offset="1">
          <p class="mt-3 text-justify">
            Banyak yang memilih Jepang sebagai destinasi wisata pilihan. Tapi kalau sama keluarga enaknya kemana ya selain Tokyo Disney Land dan Disney Sea? Don’t worry! Biar kamu dan keluarga nggak bosen, ada destinasi wisata lain di Jepang yang bisa kamu coba untuk menyemarakkan quality time kamu bareng keluarga.
          </p>
        </b-col>

        <b-col cols="10" offset="1">
          <p class="mt-3 text-justify">
            <b>Nomor satu</b>, Umi no Nakamichi Kaihin Koen, Fukuoka (海 の 中道 海 浜 公園)
          </p>
        </b-col>
        <b-col cols="10" offset="1" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/200204/1.jpeg')"
            fluid
            class="content-picture"
          />
        </b-col>
        <b-col cols="10" offset="1">
          <p class="mt-3 text-justify">
            Taman Umi no Nakamichi adalah taman keluarga besar yang bisa dikunjungi sepanjang musim yang terletak di Semenanjung Uminonakamichi, Teluk Hakata, Fukuoka. Taman ini memiliki sejumlah besar atraksi yang ditujukan khusus untuk keluarga maupun anak-anak. Umi no Nakamichi punya berbagai taman bunga, kebun binatang, taman bermain, taman air, fasilitas olahraga, dan tempat untuk melihat hewan laut. Karena ukurannya yang luassssss, kamu bisa menyewa sepeda. Jangan lupa bawa snack dan air minum yang banyak ya!
          </p>
        </b-col>

        <b-col cols="10" offset="1">
          <p class="mt-3 text-justify">
            <b>Nomor Dua</b>, Okinawa Churaumi Aquarium, Okinawa (沖縄美ら海水族館)
          </p>
        </b-col>
        <b-col cols="10" offset="1" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/200204/2.png')"
            fluid
            class="content-picture"
          />
        </b-col>
        <b-col cols="10" offset="1">
          <p class="mt-3 text-justify">
            Pengen lihat hewan-hewan laut secara dekat? Akuarium Okinawa Churaumi  adalah yang terbesar di dunia ketika dibuka pada tahun 1976 dan kini hanya satu peringkat di bawah Akuarium di Atlanta. Akuarium ini dibangun kembali pada tahun 2002 dan dikunjungi hingga 20 juta pengunjung pada tahun 2010. Ada 26.000 makhluk hidup di akuarium dan 740 spesies berbeda. Jangan lupa untuk selfie ya sebelum masuk karena ada patung ikan terbesar di dunia! Salah satu pameran paling populer adalah di tangki utama atau dikenal dengan Laut Kuroshio, yang dijadikan rumah bagi hiu paus berukuran 12 meter.
          </p>
        </b-col>

        <b-col cols="10" offset="1">
          <p class="mt-3 text-justify">
            <b>Nomor Tiga</b>, The Ghibli Museum (三鷹の森ジブリ美術館)
          </p>
        </b-col>
        <b-col cols="10" offset="1" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/200204/3.jpg')"
            fluid
            class="content-picture"
          />
        </b-col>
        <b-col cols="10" offset="1">
          <p class="mt-3 text-justify">
            Pecinta animasi pasti kenal My Neighbor Totoro, Princess Mononoke, Spirited Away dan Ponyo. Nah, karena kalau kamu suka sama karakter tersebut, kamu harus mengunjungi museum animasi dan seni Studio Ghibli - Hayao Miyazaki. Berlokasi di Mitaka, tepat di luar pusat kota Tokyo, Museum Ghibli sendiri dirancang sesuai gaya yang berbeda dari film-film studio, dan banyak karakter terkenal mereka ada di sana, termasuk robot karakter Castle in the Sky di taman atap. Lantai pertama museum memamerkan sejarah dan teknik animasi yang dilengkapi dengan teater kecil untuk menampilkan film pendek eksklusif Studio Ghibli. Museum ini juga memiliki kafe, area bermain anak-anak, taman di puncak gedung, dan toko souvenir.
          </p>
        </b-col>

        <b-col cols="10" offset="1">
          <p class="mt-3 text-justify">
            <b>Nomor Empat</b>, Ueno Park & Zoo, Tokyo (上 野 公園)
          </p>
        </b-col>
        <b-col cols="10" offset="1" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/200204/4.jpg')"
            fluid
            class="content-picture"
          />
        </b-col>
        <b-col cols="10" offset="1">
          <p class="mt-3 text-justify">
            Taman Ueno adalah taman umum yang berlokasi di sebelah Stasiun Ueno. Taman ini awalnya merupakan bagian dari Kuil Kaneiji, yang dulunya merupakan salah satu kuil terbesar dan terkaya dari keluarga klan Tokugawa yang berkuasa selama Zaman Edo. Kaneiji berdiri di timur laut ibukota untuk melindungi kota dari kejahatan, seperti Kuil Enryakuji di Kyoto. Selain taman dan kuil tradisional ada banyak museum seperti Museum Nasional Tokyo, Museum Nasional Seni Barat, Museum Seni Metropolitan Tokyo dan Museum Sains Nasional. Ini juga merupakan rumah bagi Kebun Binatang Ueno, kebun binatang pertama di Jepang. Ada 500 jenis binatang yang jarang kamu temui di Kebun Binatang lain seperti Okapi, Kucing Pallas, Kura-kura Galapagos, Aye-aye hingga Monyet Merah khas Jepang dan Panda! Pokoknya happy banget deh!
          </p>
        </b-col>
      </b-row>
    </b-container>

    <!-- mobile -->
    <b-container class="d-block d-sm-none" style="margin-top: -5em;">
      <b-row class="m-1 px-1 py-3 sg-rounded-container">
        <b-col cols="12">
          <h4>Destinasi Wisata Keluarga Cemara</h4>
        </b-col>

        <b-col cols="12">
          <p class="mt-3 text-justify">
            &emsp;Banyak yang memilih Jepang sebagai destinasi wisata pilihan. Tapi kalau sama keluarga enaknya kemana ya selain Tokyo Disney Land dan Disney Sea? Don’t worry! Biar kamu dan keluarga nggak bosen, ada destinasi wisata lain di Jepang yang bisa kamu coba untuk menyemarakkan quality time kamu bareng keluarga.
          </p>
        </b-col>

        <b-col cols="12">
          <p class="mt-3 text-justify">
            <b>Nomor satu</b>, Umi no Nakamichi Kaihin Koen, Fukuoka (海 の 中道 海 浜 公園)
          </p>
        </b-col>
        <b-col cols="12" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/200204/1.jpeg')"
            fluid
            class="content-picture"
          />
        </b-col>
        <b-col cols="12">
          <p class="mt-3 text-justify">
            Taman Umi no Nakamichi adalah taman keluarga besar yang bisa dikunjungi sepanjang musim yang terletak di Semenanjung Uminonakamichi, Teluk Hakata, Fukuoka. Taman ini memiliki sejumlah besar atraksi yang ditujukan khusus untuk keluarga maupun anak-anak. Umi no Nakamichi punya berbagai taman bunga, kebun binatang, taman bermain, taman air, fasilitas olahraga, dan tempat untuk melihat hewan laut. Karena ukurannya yang luassssss, kamu bisa menyewa sepeda. Jangan lupa bawa snack dan air minum yang banyak ya!
          </p>
        </b-col>

        <b-col cols="12">
          <p class="mt-3 text-justify">
            <b>Nomor Dua</b>, Okinawa Churaumi Aquarium, Okinawa (沖縄美ら海水族館)
          </p>
        </b-col>
        <b-col cols="12" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/200204/2.png')"
            fluid
            class="content-picture"
          />
        </b-col>
        <b-col cols="12">
          <p class="mt-3 text-justify">
            Pengen lihat hewan-hewan laut secara dekat? Akuarium Okinawa Churaumi  adalah yang terbesar di dunia ketika dibuka pada tahun 1976 dan kini hanya satu peringkat di bawah Akuarium di Atlanta. Akuarium ini dibangun kembali pada tahun 2002 dan dikunjungi hingga 20 juta pengunjung pada tahun 2010. Ada 26.000 makhluk hidup di akuarium dan 740 spesies berbeda. Jangan lupa untuk selfie ya sebelum masuk karena ada patung ikan terbesar di dunia! Salah satu pameran paling populer adalah di tangki utama atau dikenal dengan Laut Kuroshio, yang dijadikan rumah bagi hiu paus berukuran 12 meter.
          </p>
        </b-col>

        <b-col cols="12">
          <p class="mt-3 text-justify">
            <b>Nomor Tiga</b>, The Ghibli Museum (三鷹の森ジブリ美術館)
          </p>
        </b-col>
        <b-col cols="12" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/200204/3.jpg')"
            fluid
            class="content-picture"
          />
        </b-col>
        <b-col cols="12">
          <p class="mt-3 text-justify">
            Pecinta animasi pasti kenal My Neighbor Totoro, Princess Mononoke, Spirited Away dan Ponyo. Nah, karena kalau kamu suka sama karakter tersebut, kamu harus mengunjungi museum animasi dan seni Studio Ghibli - Hayao Miyazaki. Berlokasi di Mitaka, tepat di luar pusat kota Tokyo, Museum Ghibli sendiri dirancang sesuai gaya yang berbeda dari film-film studio, dan banyak karakter terkenal mereka ada di sana, termasuk robot karakter Castle in the Sky di taman atap. Lantai pertama museum memamerkan sejarah dan teknik animasi yang dilengkapi dengan teater kecil untuk menampilkan film pendek eksklusif Studio Ghibli. Museum ini juga memiliki kafe, area bermain anak-anak, taman di puncak gedung, dan toko souvenir.
          </p>
        </b-col>

        <b-col cols="12">
          <p class="mt-3 text-justify">
            <b>Nomor Empat</b>, Ueno Park & Zoo, Tokyo (上 野 公園)
          </p>
        </b-col>
        <b-col cols="12" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/200204/4.jpg')"
            fluid
            class="content-picture"
          />
        </b-col>
        <b-col cols="12">
          <p class="mt-3 text-justify">
            Taman Ueno adalah taman umum yang berlokasi di sebelah Stasiun Ueno. Taman ini awalnya merupakan bagian dari Kuil Kaneiji, yang dulunya merupakan salah satu kuil terbesar dan terkaya dari keluarga klan Tokugawa yang berkuasa selama Zaman Edo. Kaneiji berdiri di timur laut ibukota untuk melindungi kota dari kejahatan, seperti Kuil Enryakuji di Kyoto. Selain taman dan kuil tradisional ada banyak museum seperti Museum Nasional Tokyo, Museum Nasional Seni Barat, Museum Seni Metropolitan Tokyo dan Museum Sains Nasional. Ini juga merupakan rumah bagi Kebun Binatang Ueno, kebun binatang pertama di Jepang. Ada 500 jenis binatang yang jarang kamu temui di Kebun Binatang lain seperti Okapi, Kucing Pallas, Kura-kura Galapagos, Aye-aye hingga Monyet Merah khas Jepang dan Panda! Pokoknya happy banget deh!
          </p>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="mt-3" />
  </div>
</template>

<script>
// external dependencies

// custom component
import Jumbotron from '@/components/Jumbotron'

// api call

export default {
  name: 'Content_Article200204-destinasi-wisata-keluarga-cemara',
  components: {
    Jumbotron
  },
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.content-picture {
  box-shadow: 0px 10px 10px -5px rgba(0, 0, 0, 0.5);
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/Content/Article200204-destinasi-wisata-keluarga-cemara.vue